package com.zq.webproject.utils

import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import org.w3c.dom.events.Event

/**
 * Web 平台网络监听器实现
 * 使用浏览器 navigator.onLine API
 */
class WebNetworkMonitor : NetworkMonitor {
    private val _isNetworkAvailable = MutableStateFlow(checkNetworkAvailable())
    override val isNetworkAvailable: StateFlow<Boolean> = _isNetworkAvailable.asStateFlow()
    
    private val onlineListener: (Event) -> Unit = {
        println("NetworkMonitor [Web] - 网络已连接")
        _isNetworkAvailable.value = true
    }
    
    private val offlineListener: (Event) -> Unit = {
        println("NetworkMonitor [Web] - 网络已断开")
        _isNetworkAvailable.value = false
    }
    
    override fun startMonitoring() {
        println("NetworkMonitor [Web] - 开始监听网络状态")
        
        // 添加事件监听器
        window.addEventListener("online", onlineListener)
        window.addEventListener("offline", offlineListener)
    }
    
    override fun stopMonitoring() {
        println("NetworkMonitor [Web] - 停止监听网络状态")
        
        // 移除事件监听器
        window.removeEventListener("online", onlineListener)
        window.removeEventListener("offline", offlineListener)
    }
    
    private fun checkNetworkAvailable(): Boolean {
        return js("navigator.onLine") as Boolean
    }
}

actual fun getNetworkMonitor(): NetworkMonitor = WebNetworkMonitor()
